<template>
  <div>
    <!-- {{subCategory}} -->
    <ag-grid-vue
      style="width: 100%; height: 450px"
      class="ag-theme-alpine"
      :columnDefs="columnDefs"
      :rowData="rowData"
      :rowSelection="rowSelection"
      :setQuickFilter="updateSearchQuery"
      :gridOptions="gridOptions"
      @grid-ready="onGridReady"
      suppressDragLeaveHidesColumns
      suppressMovableColumns
      checkboxSelection="true"
    >
    </ag-grid-vue>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { AgGridVue } from "ag-grid-vue";
import { mapGetters } from "vuex";
import Cookie from "js-cookie";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import iconEditCheck from "../Table/components/iconEditCheck.vue";
import iconDetailSubAsset from "../Table/components/iconDetailSubAsset.vue";
import btnConfirmUser from "../Table/components/btnConfirmUser.vue";
import iconDeleteCheck from "../Table/components/iconDeleteCheck.vue";
export default {
  components: {
    AgGridVue,
    iconEditCheck,
    btnConfirmUser,
    iconDetailSubAsset,
    iconDeleteCheck,
  },
  props: ["page", "perPage"],
  data() {
    return {
      columnDefs: null,
      rowSelection: "multiple",
      gridOptions: {
        rowHeight: 50,
        defaultColDef: {
          resizable: true,
        },
      },
      gridApi: "sizeColumnsToFit",
      id_user: null,
    };
  },

  beforeMount() {
    this.columnDefs = [
      {
        headerName: this.$t("count.order"),
        field: "index",
        // headerCheckboxSelection: true,
        // headerCheckboxSelectionFilteredOnly: true,
        // checkboxSelection: true,
        maxWidth: 110,
      },
      {
        headerName: this.$t("category.sub_asset"),
        field: "name",
        sortable: true,
        minWidth: 200,
        flex: 1,
        suppressSizeToFit: true,
      },
      // ----------- Custom id 4 ------------
      {
        headerName: this.$t("model.model_total"),
        field: "model_total",
        flex: 1,
        minWidth: 150,
        suppressSizeToFit: true,
        hide: !this.canUseCustom4,
      },
      {
        headerName: this.$t("model.model"),
        field: "model_list",
        flex: 1,
        minWidth: 180,
        suppressSizeToFit: true,
        hide: !this.canUseCustom4,
      },
      {
        headerName: this.$t("model.manage_model"),
        field: "manage_model",
        flex: 1,
        minWidth: 180,
        suppressSizeToFit: true,
        cellRenderer: "iconDetailSubAsset",
        hide: !this.canUseCustom4,
      },
      // ----------- END Custom id 4 ------------
      {
        headerName: this.$t("category.manage"),
        field: "edit",
        cellRendererFramework: "iconEditCheck",
        maxWidth: 130,
        suppressSizeToFit: true,
      },
      {
        headerName: this.$t("category.delete"),
        field: "delete",
        cellRendererFramework: "iconDeleteCheck",
        maxWidth: 130,
        suppressSizeToFit: true,
      },
    ];
  },
  computed: {
    ...mapGetters({
      subCategory: "subcategory",
      canUseCustom4: "canUseCustom4",
    }),
    rowData() {
      // console.log(this.dataTable, "dataTable");
      return this.subCategory.map((subcategory, index) => {
        // if(user.user.email ===)
        // console.log(user);
        return {
          index: (this.page - 1) * this.perPage + index + 1,
          name: subcategory.name,
          edit: { id_user: subcategory.id_sub_category },
          delete: subcategory,
          // ----------- Custom id 4 ------------
          model_total: subcategory.total_sub_categories,
          model_list: subcategory.list_sub_categories || "-",
          manage_model: subcategory.id_sub_category,
          // ----------- END Custom id 4 ------------
        };
      });
    },
  },
  watch: {
    searchText() {
      this.updateSearchQuery(this.searchText);
    },
  },
  mounted() {
    // alert(this.$route.params.id_category)
    let cookie = Cookie.get("cookielogin");
    if (cookie) {
      let cookiejson = JSON.parse(cookie);
      this.id_user = cookiejson.id_user;
    }
    this.gridApi = this.gridOptions.api;
  },
  methods: {
    onGridReady() {
      // this.gridApi.sizeColumnsToFit();
    },
    getSelectedRowData() {
      let selectedNodes = this.gridApi.getSelectedNodes();
      let selectedData = selectedNodes.map((node) => node.data);
      return selectedData;
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
      this.gridApi.refreshCells();
    },
  },
};
</script>

<style scoped>
* >>> .ag-header-cell-label {
  justify-content: center;
}
* >>> .ag-header-row-column {
  background: transparent linear-gradient(180deg, #007afe 0%, #013f81 100%);
  color: white;
}
</style>
